import i18n from '@/plugins/i18n';
import rootModule from '@/app/shared/state/root';
import { setDocumentLanguage } from './locale-utils'

export function changeLocale(locale: string): void {
  i18n.locale = locale;
  rootModule.setSelectedLocale(locale);
  setDocumentLanguage(locale);
}
